import { Text } from "@radix-ui/themes";

import { Callout } from "../../../common/components";

type Props = {
  message: string;
};

export const NoData = ({ message }: Props) => {
  return (
    <Callout color="gray">
      <Text>{message}</Text>
    </Callout>
  );
};
